import { useContext, useEffect, useState } from "react"
import { AppContext } from "../context/context"
import UiButton1 from "../components/ui_button1"
import UiInput1 from "../components/ui_input1"
import UiButton3 from "../components/ui_button3"

const Impersonate = () => {

    return false;
    const {
        ww,
        neonUser,
        fetchData,
        setToastContent,
        toastInit,
        getNeonUser,
    } = useContext(AppContext)

    const [selecting, setSelecting] = useState(false)
    const [selectedAgency, setSelectedAgency] = useState(null)
    const [agencyList, setAgencyList] = useState([])
    const [search, setSearch] = useState("")
    const [roles] = useState(["admin", "normal"])
    const [selectedRole, setSelectedRole] = useState("")
    const [entityList, setEntityList] = useState([])
    const [selectedEntities, setSelectedEntities] = useState([])



    const getAllAgency = async () => {

        let sql = `SELECT * FROM agency WHERE user_owner_int_id IN (SELECT id FROM auth0_user WHERE role = 'owner')`

        try {
            let resp = await fetchData(sql, '/neon-query')

            console.log({ getAllAgency: resp })
            setAgencyList(resp)
        }
        catch (err) {
            console.log("ERROR IN GET ALL AGENCY", err)
            return []
        }


    }

    const getEntityList = async () => {

        let sql = `
        SELECT * FROM brand WHERE agency_id = '${selectedAgency.agency_id}' ORDER BY UPPER(brand) ASC    
        `;
        let resp = await fetchData(sql, "/neon-query")

        console.log({ getEntityList: { resp, sql } })
        setEntityList(resp)
    }


    const addRemoveEntity = (x) => {
        if (selectedEntities.map(xx => xx.id).includes(x.id)) {
            setSelectedEntities([...selectedEntities.filter(xx => xx.id != x.id)])
            return
        }
        else {
            setSelectedEntities([...selectedEntities, x])
            return
        }
    }

    const impersonationHandler = async () => {

        if (!selectedAgency || !selectedRole) {
            setToastContent("ERROR! Agency and role must not be empty.")
            toastInit.show()
            return
        }

        let sql = `UPDATE auth0_user SET 
            impersonate_role = '${selectedRole}',
            all_entities = ${selectedRole == 'admin' ? true : false},
            entity_id_list = '{${selectedEntities.length > 0 ? selectedEntities.map(x => x.brand_entity_id).join(",") : ""}}',
            agency_id = ${selectedAgency.agency_id},
            internal_hidden = true
            WHERE id = ${neonUser.user.id}
        `



        try {
            let resp = await fetchData(sql, '/neon-query')
            console.log({ impersonationHandler: resp })
            setToastContent("Impersonation Updated")
            toastInit.show()
            setSelecting(false)
            getNeonUser()
        }
        catch (err) {
            console.log("ERROR IN IMPERSONATION HANDLER", { err })
            return
        }

        return
    }

    useEffect(() => {
        console.log({ selectedAgency })
        setSelectedEntities([])
        if (selectedAgency) getEntityList()
    }, [selectedAgency])

    useEffect(() => {
        if (neonUser.id) {
            getAllAgency()
        }
    }, [neonUser])

    return (
        <>not in service</>
    )

    return (

        <div className={"gap-3 d-flex flex-column " + (ww < 400 ? "px-3 pt-4 " : "p-4")} >
            <p className=" mb-1 fs-4">Impersonate</p>
            {selecting ?
                <div className={"container1 " + (ww < 400 ? "px-2" : "px-4")}>

                    <duv className="d-flex flex-column gap-3">
                        <div>
                            <p className="poppins mb-1 fw-bold">Select Agency </p>
                            <div className="d-flex gap-1 dropup-center" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" >
                                <UiInput1 dropdown={true} readOnly={true} value={selectedAgency ? selectedAgency.agency_name : '-select-'} />

                            </div>
                            <ul className="dropdown-menu " >
                                <div className="px-2">
                                    <input type="text" value={search} onChange={(e) => { setSearch(e.target.value) }} className="form-control form-control-sm mb-1 poppins" placeholder="search..." />
                                </div>


                                {agencyList && agencyList.filter(x => x.agency_name.toLowerCase().includes(search.toLowerCase())).map(x => (
                                    <li onClick={() => setSelectedAgency(x)} className="px-2 d-flex flex-column gap-1" style={{ maxHeight: 200, overflowY: 'auto' }}>
                                        <p className="poppins my-1  dropdown-item">{x.agency_name}</p>
                                    </li>
                                ))
                                }

                            </ul>
                        </div>
                        <div className="">
                            <p className="poppins mb-1 fw-bold">Select Role</p>
                            <div className="d-flex  gap-3">

                                {roles.map(x => (
                                    <div className="d-flex gap-1">
                                        <input onChange={e => setSelectedRole(e.target.value)} className="align-self-center" type="radio" name="role" value={x} /> <span className="poppins text-capitalize">
                                            {x == 'normal' ? 'Read only' : x}
                                        </span>
                                    </div>
                                ))

                                }
                            </div>
                        </div>



                        <div className="" >
                            <p className="poppins fw-bold mb-1">Brands/Accounts</p>
                            <div className="d-flex gap-1 dropdown">
                                <div style={{ width: ww < 400 ? "100%" : 350 }} data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                    <UiInput1 dropdown={true} readOnly={true} value={(selectedEntities.length || 'No') + (selectedEntities.length > 1 ? " Brands/Accounts" : " Brand/Account")} />
                                </div>

                                <ul className="dropdown-menu " >
                                    <div className="px-2">
                                        <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className="form-control form-control-sm mb-1 poppins" placeholder="search..." />
                                    </div>
                                    <li className="px-2 d-flex flex-column gap-1" style={{ maxHeight: 200, overflowY: 'auto' }}>

                                        {entityList && entityList.map(x => (
                                            <div key={x.id} style={{ maxWidth: 200, cursor: "pointer" }} className="d-flex gap-2 " onClick={() => addRemoveEntity(x)}>
                                                {selectedEntities.map(xx => xx.id).includes(x.id) ?
                                                    <i className="bi bi-check-square"></i>
                                                    :
                                                    <i className="bi bi-square"></i>
                                                }
                                                <p className="poppins text-truncate mb-0" title={x.brand}> {x.brand}</p>
                                            </div>
                                        ))

                                        }

                                    </li>

                                </ul>

                            </div>

                        </div>

                        <div className="d-flex gap-3 my-4" >
                            <UiButton3 text="Cancel" left={false} w={200} submit={() => setSelecting(false)} />
                            <UiButton1 text="Submit" width={200} submit={impersonationHandler} />


                        </div>
                    </duv>



                </div>
                :
                <>

                    <div className={"container1 " + (ww < 400 ? "px-2" : "px-4")}>
                        {neonUser.user.impersonate_role ?
                            <p className="poppins ">Your are impersonating as a user that belongs to agency '<span className="fw-bold">{neonUser.agency.agency_name}</span>'.</p>

                            :
                            <p className="poppins ">You are not impersonating anyone yet.</p>

                        }
                        <UiButton1 text="Change" width={150} submit={() => setSelecting(true)} />
                    </div>
                </>
            }

        </div>

    )
}

export default Impersonate